import React, { Fragment } from 'react'
import { getImageUrl } from 'utils/helper'
import ToolCheckIcon from 'components/Common/SvgIcons/ToolCheckIcon'
import { Tool } from '../../../__generated__/api-types-and-hooks'

export interface IToolCardProps {
  tool: Tool
  selectedTool: Tool[]
  handleSelectedTool: (id: string, tool: Tool) => void
}
const ToolCard = ({ tool, selectedTool, handleSelectedTool }: IToolCardProps) => {
  const showCheckMark = selectedTool.find((toolSelected) => toolSelected.id === tool.id)

  return (
    <Fragment>
      <span className="all-tools-modal-body">
        {showCheckMark && (
          <span className="all-tools-modal-body-icon">
            <ToolCheckIcon />
          </span>
        )}
        <span
          className={`
          ${
            !showCheckMark ? 'all-tools-modal-body-un-active' : 'all-tools-modal-body-active'
          } all-tools-modal-body-box`}
          onClick={() => handleSelectedTool(tool.id ?? '', tool)}
        >
          {tool.imageUrl ? (
            <img
              src={getImageUrl(tool.imageUrl)}
              className=" all-tools-modal-body-img"
              alt={`${tool?.toolName}`}
            />
          ) : (
            <span className={`all-tools-modal-body-span`} />
          )}
        </span>
        <span className=" all-tools-modal-body-text">
          <label>{tool?.toolDisplayName ?? tool?.toolName}</label>
        </span>
      </span>
    </Fragment>
  )
}

export default ToolCard
